import { IcServer } from '@assets/icons/40x40';
import { SensorOrSubSensorInfoByType } from '@components/cockpit/panels/monitoring/monitoring.types';
import DataSheetCard from '@components/common/layout/DataSheetCard';
import { useCameraCommand } from '@hooks/useCameraCommand';
import { useIntl } from 'react-intl';

import { SensorTypeEnum } from '@/types/sensor/sensors';

type Props = {
  sensorOrSubSensorInfo: SensorOrSubSensorInfoByType<SensorTypeEnum.ZMER>;
  replayMode: boolean;
};

export default function ZmerMaintenanceActions({ sensorOrSubSensorInfo, replayMode }: Readonly<Props>) {
  const { formatMessage } = useIntl();

  const useCamera = useCameraCommand({
    monitoringSensor: sensorOrSubSensorInfo,
  });

  const charmNotConfigured =
    !sensorOrSubSensorInfo.configuration.charmUsername || !sensorOrSubSensorInfo.configuration.charmPassword;
  const charmNotConnected = !sensorOrSubSensorInfo.status?.charmConnected;

  function infoCharm(): string {
    if (charmNotConfigured) {
      return formatMessage({ id: 'sensors.tab.maintenance.camera.notConfigured' });
    } else if (charmNotConnected) {
      return formatMessage({ id: 'sensors.tab.maintenance.camera.notConnected' });
    }
    return formatMessage({ id: 'sensors.tab.maintenance.camera.reboot' });
  }

  const rebootActions = [
    {
      action: 'reboot',
      i18nKey: 'sensors.tab.maintenance.camera.reboot',
    },
  ] as const;

  return (
    <DataSheetCard
      icon={IcServer}
      tooltip={infoCharm()}
      actions={rebootActions}
      description={formatMessage({ id: 'sensors.tab.maintenance.camera.rebootCharmDescription' })}
      isDisabled={charmNotConfigured || charmNotConnected || replayMode}
      onClick={useCamera.rebootCharm}
    />
  );
}
